/**
 * Argus — helpers pentru fs_events timeline (continuous-monitoring-fs).
 */

import { apiFetch } from './api';
import type { FsEventType } from './watchedPaths';

export interface FsEventItem {
  readonly id: number;
  readonly watchedPath: string;
  readonly eventType: FsEventType;
  readonly filePath: string;
  readonly newPath: string | null;
  readonly fileSize: number | null;
  readonly sha256: string | null;
  readonly capturedAt: string;
}

export interface FsEventsResponse {
  readonly agentId: string;
  readonly items: readonly FsEventItem[];
  readonly nextCursor: number | null;
  readonly limit: number;
}

export interface FsEventsQuery {
  readonly eventType?: readonly FsEventType[];
  readonly pathPrefix?: string;
  readonly from?: string;
  readonly to?: string;
  readonly cursor?: number;
  readonly limit?: number;
}

export async function fetchFsEvents(
  agentId: string,
  query: FsEventsQuery = {}
): Promise<FsEventsResponse> {
  const qs = new URLSearchParams();
  if (query.eventType && query.eventType.length > 0) {
    qs.set('eventType', query.eventType.join(','));
  }
  if (query.pathPrefix) {
    qs.set('pathPrefix', query.pathPrefix);
  }
  if (query.from) {
    qs.set('from', query.from);
  }
  if (query.to) {
    qs.set('to', query.to);
  }
  if (query.cursor !== undefined && query.cursor > 0) {
    qs.set('cursor', String(query.cursor));
  }
  if (query.limit) {
    qs.set('limit', String(query.limit));
  }
  const suffix = qs.toString() === '' ? '' : `?${qs.toString()}`;
  const result = await apiFetch<FsEventsResponse>(
    `/api/v1/agents/${agentId}/fs-events${suffix}`
  );
  return result.data;
}
